// App
import React from 'react';

// Constellation
import { Box, IconButton, Paragraph } from '@zillow/constellation-10';
import { IconChevronLeftFilled, IconChevronRightFilled } from '@zillow/constellation-icons';

// Misc / utils
import BackHomeLeft from '../images/icons/backHomeLeft.inline.svg';
import BackHomeRight from '../images/icons/backHomeRight.inline.svg';
import {
  buttonsContainerStyles,
  buttonsStyles,
  homeButtonStyles,
  mobileHomeButtonLeftStyles,
  mobileHomeButtonRightStyles,
} from './styles';

// Types
type ButtonPropTypes = {
  showScrollButton: boolean;
  showHomeButton: boolean;
  scrollClickHandler: () => void;
  homeClickHandler: () => void;
};

export const LeftDesktopButton = ({
  showScrollButton,
  showHomeButton,
  scrollClickHandler,
  homeClickHandler,
}: ButtonPropTypes) => {
  return (
    <Box css={buttonsContainerStyles}>
      <Box css={buttonsStyles}>
        <IconButton
          title="Previous"
          icon={<IconChevronLeftFilled />}
          tone="brand"
          shape="circle"
          emphasis="filled"
          size="sm"
          onClick={scrollClickHandler}
          disabled={!showScrollButton}
        />

        <Box css={{ ...homeButtonStyles, visibility: showHomeButton ? 'visible' : 'hidden' }}>
          <div onClick={homeClickHandler}>
            <BackHomeLeft style={{ background: 'transparent' }} />
          </div>
          <Paragraph textStyle="fineprint">My home</Paragraph>
        </Box>
      </Box>
    </Box>
  );
};

export const RightDesktopButton = ({
  showScrollButton,
  showHomeButton,
  scrollClickHandler,
  homeClickHandler,
}: ButtonPropTypes) => {
  return (
    <Box css={buttonsContainerStyles}>
      <Box css={buttonsStyles}>
        <IconButton
          title="Next"
          icon={<IconChevronRightFilled />}
          tone="brand"
          shape="circle"
          emphasis="filled"
          size="sm"
          onClick={scrollClickHandler}
          disabled={!showScrollButton}
        />

        <Box css={{ ...homeButtonStyles, visibility: showHomeButton ? 'visible' : 'hidden' }}>
          <div onClick={homeClickHandler}>
            <BackHomeRight style={{ background: 'transparent' }} />
          </div>
          <Paragraph textStyle="fineprint">My home</Paragraph>
        </Box>
      </Box>
    </Box>
  );
};

export const LeftMobileButton = ({
  showHomeButton,
  homeClickHandler,
}: Pick<ButtonPropTypes, 'showHomeButton' | 'homeClickHandler'>) => {
  return (
    <Box css={{ ...mobileHomeButtonLeftStyles, visibility: showHomeButton ? 'visible' : 'hidden' }}>
      <div onClick={homeClickHandler}>
        <BackHomeLeft style={{ background: 'transparent' }} />
      </div>
      <Paragraph textStyle="fineprint">My home</Paragraph>
    </Box>
  );
};

export const RightMobileButton = ({
  showHomeButton,
  homeClickHandler,
}: Pick<ButtonPropTypes, 'showHomeButton' | 'homeClickHandler'>) => {
  return (
    <Box css={{ ...mobileHomeButtonRightStyles, visibility: showHomeButton ? 'visible' : 'hidden' }}>
      <div onClick={homeClickHandler}>
        <BackHomeRight style={{ background: 'transparent' }} />
      </div>
      <Paragraph textStyle="fineprint">My home</Paragraph>
    </Box>
  );
};
